"use client";
import React from "react";
import { Job } from "types/booking.interface";
import ReviewCard from "../reviewCard";
import useJobReviews from "hooks/useJobReviews";

interface props {
  job: Job;
}
const JobReview: React.FC<props> = ({ job }) => {
  const { data, isLoading: isLoadingReviews } = useJobReviews(job?._id!, 5);

  return (
    <>
      <div className=" bg-white rounded-lg border border-gray-200 flex flex-col px-4 py-6">
        <div className=" flex items-center justify-between">
          <span className=" font-body font-medium leading-5 text-base lg:text-lg mt-4">
            {data?.length} Review{data?.length! > 1 ? "s" : ""}
          </span>
        </div>

        <div>
          {isLoadingReviews ? (
            <div className="flex items-center justify-center">
              <p>Loading...</p>
            </div>
          ) : (
            <div>
              {data?.length! < 1 ? (
                <div className=" flex w-full justify-center py-6">
                  <p className=" font-body font-medium text-muted leading-5 text-sm">
                    No job reviews
                  </p>
                </div>
              ) : (
                <div>
                  {data?.map((review) => (
                    <ReviewCard key={review._id} review={review} />
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default JobReview;
